import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { OrderNumberInventoryResponse } from '../../shared/models/generated/ziroModels';

@Injectable()
export class NumberInventoriesResource {
  private _http = inject(HttpClient);

  private _url = '/services/microsoft/orders/number-inventories';

  get(): Observable<OrderNumberInventoryResponse> {
    return this._http.get<OrderNumberInventoryResponse>(this._url);
  }
}
